import { render, staticRenderFns } from "./ModalValidation.vue?vue&type=template&id=74f1a1e8&"
import script from "./ModalValidation.vue?vue&type=script&lang=js&"
export * from "./ModalValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports